import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { workspaceScopedQueryKey } from "../utils/workspaceQueryScope";

/** Catálogo usado no Chat/softphone — mesma chave = um GET compartilhado. */
export const CHANNELS_CATALOG_PAGE = 1;
export const CHANNELS_CATALOG_LIMIT = 200;

export const useChannels = (
  page = CHANNELS_CATALOG_PAGE,
  limit = CHANNELS_CATALOG_LIMIT,
  search = ""
) => {
  const queryClient = useQueryClient();

  const query = useQuery(
    workspaceScopedQueryKey("channels", page, limit, search),
    () =>
      fetchData(
        `/channels?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      ),
    {
      // Catálogo muda pouco; cache maior evita refetchs duplicados no boot
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        channels: response.data || [],
        pagination: response.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (channel) => {
      const method = channel.id ? "PUT" : "POST";
      const endpoint = channel.id ? `/channels/${channel.id}` : `/channels`;
      return fetchData(endpoint, method, channel);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("channels");
        queryClient.invalidateQueries("filter-options");
      },
    }
  );

  const deleteMutation = useMutation(
    (id) =>
      fetchData(`/channels/${id}`, "DELETE"),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("channels");
        queryClient.invalidateQueries("filter-options");
      },
    }
  );

  return { ...query, updateMutation, deleteMutation };
};
